import { useUser } from '@clerk/react';
import { Box } from '@mui/material';
import { AgText } from 'src/components/ui';

export default function AiChatLanding() {
  const { user } = useUser();

  return (
    <Box
      sx={{
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        px: '24px',
        mt: 2,
        minHeight: 0,
        position: 'relative',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 1,
          textAlign: 'center',
          padding: 4,
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="40" viewBox="0 0 42 40" fill="none">
          <path
            d="M31.1679 0.215088L33.5857 4.74861L38.1192 7.16648L33.5857 9.58436L31.1679 14.1179L28.75 9.58436L24.2165 7.16648L28.75 4.74861L31.1679 0.215088ZM14.6679 5.94425L19.5567 15.1109L28.7234 19.9998L19.5567 24.8887L14.6679 34.0554L9.77896 24.8887L0.612305 19.9998L9.77896 15.1109L14.6679 5.94425ZM36.0567 27.9443L33.0013 22.2152L29.9457 27.9443L24.2165 30.9998L29.9457 34.0554L33.0013 39.7846L36.0567 34.0554L41.7859 30.9998L36.0567 27.9443Z"
            fill="url(#paint0_linear_9_1452)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_9_1452"
              x1="21.1991"
              y1="0.215088"
              x2="21.1991"
              y2="39.7846"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#6E9A07" />
              <stop offset="1" stopColor="#AEC52E" />
            </linearGradient>
          </defs>
        </svg>
        <AgText size="h6">Hello, {user.firstName}!</AgText>
        <AgText size="14">How can I help you today?</AgText>
      </Box>
    </Box>
  );
}
